import { Flex } from 'antd';
import { useRef, PointerEvent } from 'react';

import styles from './index.module.scss';

type Position = {
  x: number;
  y: number;
};

const ImagePointer = ({
  position,
  image,
  setPosition,
}: {
  position: Position;
  image: string;
  setPosition?: (value: Position) => void;
}) => {
  const imageRef = useRef<HTMLImageElement>(null);

  const calculatePosition = (event: PointerEvent<HTMLImageElement>) => {
    const imageElement = imageRef.current;
    if (!imageElement) {
      return null;
    }

    // retrieve position and size of the viewport
    const rect = imageElement.getBoundingClientRect();

    // calculate event position relative to the viewport
    // we can use event.touches[0].clientX for touch event
    const xPixels = event.clientX - rect.left;
    const yPixels = event.clientY - rect.top;

    // we use a percentage in order to display the position whatever the size of the image
    const xPercent = (xPixels / rect.width) * 100;
    const yPercent = (yPixels / rect.height) * 100;

    // final value should be between 0 and 100
    const clampedX = Math.min(100, Math.max(0, xPercent));
    const clampedY = Math.min(100, Math.max(0, yPercent));

    return {
      x: parseFloat(clampedX.toFixed(2)),
      y: parseFloat(clampedY.toFixed(2)),
    };
  };

  const handlePointerDown = (event: PointerEvent<HTMLImageElement>) => {
    event.preventDefault();

    // we only want to display the position of the defect
    if (!setPosition) {
      return;
    }

    const newPosition = calculatePosition(event);
    if (newPosition) {
      setPosition(newPosition);
    }
  };

  return (
    <Flex justify="center">
      <div className={styles.imageContainer}>
        <img
          ref={imageRef}
          src={image}
          className={styles.defectImage}
          onPointerDown={handlePointerDown}
          onTouchMove={(e) => e.preventDefault()}
        />
        <div
          className={styles.redCircle}
          style={{
            left: `${position.x}%`,
            top: `${position.y}%`,
          }}
        />
      </div>
    </Flex>
  );
};

export default ImagePointer;
